export const parseIcon = (icon) => icon &&
    { type: icon.split(";")[0], icon: icon.split(";")[1] };
